import { jsx as _jsx } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";
var getLimitedStockTextComponent = function(param) {
    var optionAvailableUnit = param.optionAvailableUnit, optionUnitMultiplier = param.optionUnitMultiplier, productState = param.productState;
    var availableUnits = optionAvailableUnit !== null && optionAvailableUnit !== void 0 ? optionAvailableUnit : Number.POSITIVE_INFINITY;
    var unitMultiplier = optionUnitMultiplier !== null && optionUnitMultiplier !== void 0 ? optionUnitMultiplier : 1;
    var comesInCases = unitMultiplier !== 1;
    var availableQuantity = comesInCases ? Math.floor(availableUnits / unitMultiplier) : availableUnits;
    var isLimitedStock = availableQuantity > 0 && availableQuantity <= 3;
    var isSalesPaused = productState === IProduct.State.SALES_PAUSED;
    if (!isLimitedStock || isSalesPaused) {
        return null;
    }
    return comesInCases ? /*#__PURE__*/ _jsx(Typography, {
        color: Decorative.shade.orange,
        style: {
            fontStyle: "italic",
            width: "auto"
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "aSR7Hu",
            defaultMessage: [
                {
                    type: 6,
                    value: "availableQuantity",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 0,
                                    value: "Only "
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " case left!"
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 0,
                                    value: "Only "
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " cases left!"
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                availableQuantity: availableQuantity
            })
        })
    }) : /*#__PURE__*/ _jsx(Typography, {
        color: Decorative.shade.orange,
        style: {
            fontStyle: "italic",
            width: "auto"
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "qHhL47",
            defaultMessage: [
                {
                    type: 0,
                    value: "Only "
                },
                {
                    type: 1,
                    value: "availableQuantity"
                },
                {
                    type: 0,
                    value: " left!"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                availableQuantity: availableQuantity
            })
        })
    });
};
export var productTileCaselinePropsAdaptor = function(param) {
    var caseSizeText = param.caseSizeText, optionAvailableUnit = param.optionAvailableUnit, optionUnitMultiplier = param.optionUnitMultiplier, productState = param.productState, isLoggedIn = param.isLoggedIn;
    var limitedStockText = getLimitedStockTextComponent({
        optionAvailableUnit: optionAvailableUnit,
        optionUnitMultiplier: optionUnitMultiplier,
        productState: productState
    });
    var isSalesPaused = productState === IProduct.State.SALES_PAUSED;
    return {
        isLoggedIn: isLoggedIn,
        caseSizeText: caseSizeText,
        limitedStockText: limitedStockText,
        isSalesPaused: isSalesPaused
    };
};
